// circle — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 50%;
    box-sizing: border-box;
    width: var(--run-circle-size, 2.5rem);
    height: var(--run-circle-size, 2.5rem);
    font-size: var(--run-circle-font-size, var(--run-font-size-base));
    font-weight: 400;
    line-height: var(--run-circle-line-height, var(--run-font-semantic-line-height-body));
    font-family: var(--run-wf-font-family);
    box-shadow: none;
  }

  :host {
    background: var(--run-wf-surface);
    border: 1px dashed var(--run-wf-border);
    color: var(--run-wf-text);
  }

  :host([variant="solid"]) {
    background: var(--run-wf-surface);
    border: 1px dashed var(--run-wf-border);
    color: var(--run-wf-text);
  }

  :host([variant="ghost"]) {
    background: var(--run-wf-surface);
    border: 1px dashed var(--run-wf-border);
    color: var(--run-wf-text);
  }

  :host([intent="neutral"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="solid"][intent="neutral"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="ghost"][intent="neutral"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }

  :host([intent="primary"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="solid"][intent="primary"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="ghost"][intent="primary"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }

  :host([intent="success"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="solid"][intent="success"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="ghost"][intent="success"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }

  :host([intent="warning"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="solid"][intent="warning"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="ghost"][intent="warning"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }

  :host([intent="danger"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="solid"][intent="danger"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="ghost"][intent="danger"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }

  :host([intent="info"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="solid"][intent="info"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }
  :host([variant="ghost"][intent="info"]) {
    background: var(--run-wf-surface);
    border-color: var(--run-wf-border);
    color: var(--run-wf-text);
  }

  slot {
    display: contents;
  }
`;

export function render(host) {
  const { size, variant, intent } = host;
  host.shadowRoot.innerHTML = `<slot></slot>`;
}